import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { UserInviteExpiration } from '../../types/user-invite-expiration.model';

@Component({
	imports: [TranslocoModule, DatePipe],
	selector: 'ctx-user-invite-expiration-row',
	templateUrl: './user-invite-expiration-row.component.html',
	styleUrl: './user-invite-expiration-row.component.scss',
	host: { class: 'contents' },
})
export class UserInviteExpirationRowComponent {
	readonly state = input<UserInviteExpiration | undefined>(undefined);
}
